module.exports = __webpack_public_path__ + "static/media/53.c8566152.jpg";